<template>
  <div>
    <span v-show="!editable">{{value}}</span>
    <input v-show="editable" :value="value" @blur="updateValue" v-bind="$attrs" :placeholder="placeholder"/>
    <span class="tip">{{errorMessage}}</span>
  </div>
</template>

<script>
  import MyButton from '@/components/MyButton'
  import ApiClient from "@/api/ApiClient";

  export default {
    name: "tableEdit",
    components: {
      MyButton,
    },
    props: {
      value: {},
      editable: {type: Boolean, default: false},
      rules: {type: Array, default: () => []} , // [{validate: function(value){return true | false}, message: "..."}, ...]
      placeholder:{type:String}
    },
    data() {
      return {
        show: false,
        errorMessage: null
      }
    },
    methods: {
      updateValue(event) {
        this.$emit('input', event.target.value)
      },
      validate() {
        this.errorMessage = _(this.rules).reduce((msg, rule) => {
          if (msg) return msg;
          return rule.validate(this.value) ? null : rule.message;
        }, null);
        return !this.errorMessage;
      }
    },
    updated() {
      if(this.editable){this.validate();}
    },
    mounted() {
      this.$emit('created', this);
    }
  }
</script>

<style scoped lang="less">
  @import '~@/app.less';

  input{
    width: 50%;
    margin-left: -10px;
    height: 32px;
    padding: 4px 7px;
    font-size: 12px;
    outline: none;
    border: 1px solid #dddee1;
    border-radius: 4px;
    color:#495060;
  }
  .tip{
  color:red;
}
  ::-webkit-input-placeholder { /* WebKit browsers */
    color:    #999;
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color:    #999;
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color:    #999;
  }
  :-ms-input-placeholder { /* Internet Explorer 10+ */
    color:    #999;
  }
</style>



// WEBPACK FOOTER //
// src/components/tableEdit.vue